import { render } from "./NavDefaultLayout.vue?vue&type=template&id=1aff2be4"
import script from "./NavDefaultLayout.vue?vue&type=script&lang=js"
export * from "./NavDefaultLayout.vue?vue&type=script&lang=js"

import "./NavDefaultLayout.vue?vue&type=style&index=0&id=1aff2be4&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__